import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import { ThemeProvider } from 'styled-components'
import { MainTheme as theme } from '../themes'
import Header from './header'
import './layout.css'

const Layout = ({ children, pageResources }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={(data) => (
      <>
        <Helmet>
          <html lang="en" />
          <meta charSet="utf-8" />
          <meta name="description" content="" />
          <meta name="keywords" content="painting, artist, simone fazio, " />
          <title>{data.site.siteMetadata.title}</title>
        </Helmet>
        <Header
          siteTitle={data.site.siteMetadata.title}
          pageResources={pageResources}
        />
        <ThemeProvider theme={theme}>
          <div>{children}</div>
        </ThemeProvider>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
